import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ZoomIn } from "lucide-react";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { facilityGallery, stats, company } from "../mock/mock";

const Facility = () => {
  const [active, setActive] = useState(null);

  return (
    <div className="bg-white">
      {/* Header */}
      <section className="bg-[#141414] py-16">
        <div className="max-w-[1140px] mx-auto px-5">
          <p className="text-[#D80000] font-heading font-semibold tracking-widest text-sm">OUR FACILITY</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mt-3">Inside Our Manufacturing Floor</h1>
          <p className="text-white/60 mt-4 max-w-2xl">
            Everything is made under one roof. Take a look at the machines, people
            and processes that bring your parts to life at {company.name}.
          </p>
        </div>
      </section>

      {/* Stats strip */}
      <section className="border-b border-gray-100 py-10">
        <div className="max-w-[1100px] mx-auto px-5 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((st) => (
            <div key={st.label}>
              <p className="font-heading text-3xl md:text-4xl font-bold text-[#D80000]">{st.value}</p>
              <p className="text-sm text-[#1a1a1a]/70 mt-1">{st.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery */}
      <section className="py-14 md:py-20">
        <div className="max-w-[1200px] mx-auto px-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {facilityGallery.map((img, i) => (
              <button
                key={img.src}
                onClick={() => setActive(img)}
                className={`group relative overflow-hidden rounded-lg shadow-sm hover:shadow-xl ${i % 5 === 0 ? "sm:col-span-2" : ""}`}
              >
                <img
                  src={img.src}
                  alt={img.title}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-90" />
                <div className="absolute bottom-0 left-0 p-5 text-left">
                  <span className="text-[11px] font-semibold uppercase tracking-wider text-[#ff6b6b]">{img.category}</span>
                  <p className="font-heading font-semibold text-white text-lg">{img.title}</p>
                </div>
                <span className="absolute top-4 right-4 inline-flex items-center justify-center w-9 h-9 rounded-full bg-white/90 text-[#D80000] opacity-0 group-hover:opacity-100 transition-opacity">
                  <ZoomIn className="w-4 h-4" />
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#D80000] py-14">
        <div className="max-w-[820px] mx-auto px-5 text-center">
          <h2 className="font-heading text-3xl font-bold text-white">Want to see a specific capability?</h2>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-6 bg-white text-[#D80000] font-semibold px-7 py-3.5 rounded-md hover:bg-[#1a1a1a] hover:text-white">
            Book a Factory Tour <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>

      {/* Lightbox */}
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden bg-black border-0">
          {active && (
            <div>
              <img src={active.src} alt={active.title} className="w-full max-h-[70vh] object-contain bg-black" />
              <div className="p-4 bg-[#141414]">
                <span className="text-[11px] font-semibold uppercase tracking-wider text-[#ff6b6b]">{active.category}</span>
                <p className="font-heading font-semibold text-white text-lg">{active.title}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Facility;
